import BaseLinkTo from "../../Amazon/LinkTo/index";
import GlobalConstants from "../../GlobalConstants";

class AmazonLinkTo extends BaseLinkTo {

  searchSizeGender() {
    if (this.props.gender === null || this.props.gender === "Both") {
      return "";
    } else {
      return `+${encodeURIComponent(this.props.gender)}`;
    }
  }

  brandSizeLink() {
    if(this.props.brand.amazon === GlobalConstants.FILTER_AVAILABLE) {
      return `${this.baseURL()}&rh=n%3A7141123011%2Cn%3A7147444011%2Ck%3A${encodeURIComponent(this.searchSizeString())}${this.searchSizeGender()}%2Cp_89%3A${encodeURIComponent(this.props.brand.name)}${this.affiliateTag()}`;
    } else if(this.props.brand.amazon === GlobalConstants.FILTER_UNAVAILABLE){
      return `${this.baseURL()}&keywords="${encodeURIComponent(this.props.brand.name)}"+${encodeURIComponent(this.searchSizeString())}${this.searchSizeGender()}${this.affiliateTag()}`;
    } else {
      return false;
    }
  }
}

export default AmazonLinkTo;



/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/ClothingContainer/AmazonLinkTo.js
 **/